export const ADENGI_COMPANY_NAME = 'Реклама ООО МКК «А ДЕНЬГИ» ИНН: 7708400979';
export const ADENGI_URL = 'https://goto.startracking.ru/api/v1/redirect?offer_id=100509&aff_id=2&erid=2W5zFHw5F5b';
export const ADENGI_PIXEL_VIEW =
  'https://goto.startracking.ru/api/v1/impression?offer_id=100509&aff_id=2&erid=2W5zFHw5F5b';

export const ADENGI_TITLE = 'Оценивайте свои финансовые возможности и риски';

export const ADENGI_PROMO_DOCUMENT_LINK = 'https://adengi.ru/docs/Terms-of-free-first-loan.pdf';

export const ADENGI_TOKEN = '2W5zFHw5F5b';
